import { render, staticRenderFns } from "./admit.vue?vue&type=template&id=1ebc5be6&"
import script from "./admit.vue?vue&type=script&lang=js&"
export * from "./admit.vue?vue&type=script&lang=js&"
import style0 from "./admit.vue?vue&type=style&index=0&id=1ebc5be6&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports